import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from "../http/http.service";
import {
  Categories, Comment, CommentPost, CommunityBoard,
  CommunityBoardPage, HelpBoard, HelpBoardPage, HeyBoard, Keywords
} from "./board";


@Injectable()
export class BoardService {
  private url = '/api/boards/v2';

  constructor(private httpService: HttpService) {
  }

  getHeyKeyword(): Observable<Keywords> { //Complete
    return this.httpService.get('/api/pages/hey-keyword')
      .map(res => res.json() as Keywords);
  }
  getCommunityKeyword(): Observable<Keywords> { //Complete
    return this.httpService.get('/api/pages/community-keyword')
      .map(res => res.json() as Keywords);
  }
  getCategory(): Observable<Categories> { //Complete
    return this.httpService.get('/api/pages/community-category')
      .map(res => res.json() as Categories);
  }
  report(id: number): Observable<boolean> { //Complete
    return this.httpService.post(`${this.url}/${id}/report`, null)
      .map(res => res.json() as boolean);
  }
  like(id: number): Observable<boolean> { //Complete
    return this.httpService.put(`${this.url}/${id}/likes/true`, null)
      .map(res => res.json() as boolean);
  }
  commentlike(id: number): Observable<boolean> { //Complete
    return this.httpService.put(`${this.url}/comment/${id}/likes/true`, null)
      .map(res => res.json() as boolean);
  }
  unlike(id: number): Observable<boolean> { //Complete
    return this.httpService.put(`${this.url}/${id}/likes/false`, null)
      .map(res => res.json() as boolean);
  }
  commentunlike(id: number): Observable<boolean> { //Complete
    return this.httpService.put(`${this.url}/comment/${id}/likes/false`, null)
      .map(res => res.json() as boolean);
  }
  likelist(id: number): Observable<any> { //Complete
    return this.httpService.get(`${this.url}/${id}/likers`)
      .map(res => res.json() as any);
  }

  getByComment(id: number): Observable<any> { //Complete
    return this.httpService.get(`${this.url}/${id}/comments`)
      .map(res => res.json() as any);
  }
  addByComment(id: number, comment: CommentPost): Observable<Comment> { //Complete
    return this.httpService.post(`${this.url}/${id}/comments`, comment)
      .map(res => res.json() as Comment);
  }
  addByReplyComment(id: number, comment: CommentPost) { //Complete
    return this.httpService.post(`${this.url}/comment/${id}/comments`, comment)
      .map(res => res.json() as Comment);
  }
  deleteByComment(id: number) { //Complete
    return this.httpService.delete(`${this.url}/${id}/comments`)
      .map(res => res.json() as Comment);
  }

  getsByHey(page: number, location: string, search: string, tag: string, mine: boolean) { //Complete
    return this.httpService.get(
      this.url + (mine ? '/me' : '') +
      `/hey?page=${page}`
      + `${location ? `&location=${location}` : ''}`
      + `${search ? `&search=${search}` : ''}`
      + `${tag ? `&tag=${tag}` : ''}`)
      .map(res => res.json() as CommunityBoardPage);
  }
  getByHey(id: number): Observable<HeyBoard> { //Complete
    return this.httpService.get(`${this.url}/${id}`)
      .map(res => res.json() as HeyBoard);
  }
  saveByHey(board: HeyBoard) { //Complete
    if (board.id) {
      return this.httpService.put(`${this.url}/hey/${board.id}`, board)
        .map(res => res.json() as HeyBoard);
    } else {
      return this.httpService.post(`${this.url}/hey`, board)
        .map(res => res.json() as HeyBoard);
    }
  }
  deleteByBoard(id: number): Observable<any> {
    return this.httpService.delete(`${this.url}/${id}`)
      .map(res => res.json() as any);
  }


  // Community _________________________________________________
  getsByCommunity(page: number, location: string, search: string, category: string, tag: string, active: string, mine: boolean): Observable<CommunityBoardPage> {
    return this.httpService.get(
      this.url + (mine ? '/me' : '') +
      `/community?page=${page}` +
      `${location ? `&location=${location}` : ''}` +
      `${search ? `&search=${search}` : ''}` +
      `${category ? `&category=${category}` : ''}` +
      `${tag ? `&tag=${tag}` : ''}` +
      `${active ? `&active=${active}` : ''}`)
      .map(res => res.json() as CommunityBoardPage);
  }

  getByCommunity(id: number): Observable<CommunityBoard> {
    return this.httpService.get(`${this.url}/${id}`)
      .map(res => res.json() as CommunityBoard);
  }

  saveByCommunity(board: CommunityBoard): Observable<CommunityBoard> {
    if (board.id) {
      return this.httpService.put(`${this.url}/community/${board.id}`, board)
        .map(res => res.json() as CommunityBoard);
    } else {
      return this.httpService.post(`${this.url}/community`, board)
        .map(res => res.json() as CommunityBoard);
    }
  }

  // HELP _______________________________________________________
  getsByHelp(page: number, location: string, search: string, mine: boolean): Observable<HelpBoardPage> {
    return this.httpService.get(
      this.url + (mine ? '/me' : '') +
      `/help?page=${page}`
      + `${location ? `&location=${location}` : ''}`
      + `${search ? `&search=${search}` : ''}`)
      .map(res => res.json() as HelpBoardPage);
  }

  getByHelp(id: number): Observable<HelpBoard> {
    return this.httpService.get(`${this.url}/${id}`)
      .map(res => res.json() as HelpBoard);
  }

  saveByHelp(board: HelpBoard): Observable<HelpBoard> {
    if (board.id) {
      return this.httpService.put(`${this.url}/help/${board.id}`, board)
        .map(res => res.json() as HelpBoard);
    } else {
      return this.httpService.post(`${this.url}/help`, board)
        .map(res => res.json() as HelpBoard);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/service/board/board.service.ts